export default function SidebarStepUnknown() { return "Невідомий крок" }
